import { PublicClientApplication, Configuration, LogLevel } from "@azure/msal-browser";

const TENANT_ID = "88c869cb-3d6d-46e1-87f1-c158fb03fac7";
const CLIENT_ID = "2743b95f-52a5-48dc-a90a-54306bb2f35a";
export const API_SCOPE = `api://${CLIENT_ID}/access_as_user`;

const config: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: window.location.origin + "/auth-callback",
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: { cacheLocation: "sessionStorage", storeAuthStateInCookie: false },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (_lvl, msg) => console.log(msg),
      piiLoggingEnabled: false,
    },
  },
};

export const msal = new PublicClientApplication(config);
export const loginRequest = { scopes: [API_SCOPE, "User.Read"] };
